module.exports = __webpack_public_path__ + "img/paradox.1690eef0.svg";